import ErrorMessage from './ErrorMessage'
export default ErrorMessage



// WEBPACK FOOTER //
// ./src/components/inputs/ErrorMessage/index.js